import usePreselectOriginalAgent from '@/hooks/usePreselectOriginalAgent';
import useAgentsAndTimeslots from '../hooks/useAgentsAndTimeslots';
import CalendarSelectionLayout from './CalendarSelectionLayout';

const RescheduleCalendarSelection: React.FC = () => {
  const { agentsForSelectedTimeSlot } = useAgentsAndTimeslots();

  usePreselectOriginalAgent(agentsForSelectedTimeSlot);

  return <CalendarSelectionLayout isRescheduleFlow />;
};

export default RescheduleCalendarSelection;
